<mat-card class="cardWithShadow">
  <mat-card-content>
    <mat-card-title>{{ "personal_details.personal_details" | translate }}</mat-card-title>
    <mat-card-subtitle class="f-s-14">{{ "personal_details.personal_details_subtitle" | translate }}
    </mat-card-subtitle>
    <form [formGroup]="userDetailForm" (ngSubmit)="onSubmit()" class="w-100">

    <div class="row m-t-24">

          <div class="col-sm-6">
            <mat-label class="f-s-14 f-w-600 m-b-8 d-block">{{ "personal_details.name" | translate }}</mat-label>
            <mat-form-field appearance="outline" class="w-100" color="primary">
              <input matInput formControlName="name" id="name"/>
              <mat-error
                *ngIf="userDetailForm.get('name')?.hasError('required') && userDetailForm.get('name')?.touched">
                {{ "personal_details.name_required" | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-sm-6">
            <mat-label class="f-s-14 f-w-600 m-b-8 d-block">{{ "personal_details.lastname" | translate }}
            </mat-label>
            <mat-form-field appearance="outline" class="w-100">
              <input matInput formControlName="lastname" id="lastname"/>
              <mat-error
                *ngIf="userDetailForm.get('lastname')?.hasError('required') && userDetailForm.get('lastname')?.touched">
                {{ "personal_details.lastname_required" | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-sm-6">
            <mat-label class="f-s-14 f-w-600 m-b-8 d-block">{{ "personal_details.username" | translate }}</mat-label>
            <mat-form-field appearance="outline" class="w-100" color="primary">
              <input matInput formControlName="username" id="username"/>
              <mat-error
                *ngIf="userDetailForm.get('username')?.hasError('required') && userDetailForm.get('username')?.touched">
                {{ "personal_details.username_required" | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-sm-6">
            <mat-label class="f-s-14 f-w-600 m-b-8 d-block">{{ "personal_details.email" | translate }}</mat-label>
            <mat-form-field appearance="outline" class="w-100" color="primary">
              <input readonly matInput formControlName="email" id="email" class="disabled-field mdc-text-field--disabled" />
            </mat-form-field>
          </div>

          <div class="col-sm-2">
            <mat-label class="f-s-14 f-w-600 m-b-8 d-block">{{ "personal_details.prefix" | translate }}</mat-label>
            <mat-form-field appearance="outline" class="w-100" color="primary">
              <mat-select formControlName="prefix" id="prefix" (openedChange)="onPrefixDropdownOpened($event)">
                <mat-option>
                  <input matInput #filterInput placeholder="{{ 'search' | translate }}" [(ngModel)]="prefixFilter"
                    [ngModelOptions]="{ standalone: true }" (click)="$event.stopPropagation()"/>
                </mat-option>
                <mat-option *ngFor="let prefix of filteredPrefixes()" [value]="prefix.id">
                  {{ prefix.prefix }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-sm-4">
            <mat-label class="f-s-14 f-w-600 m-b-8 d-block">{{ "personal_details.phone" | translate }}</mat-label>
            <mat-form-field appearance="outline" class="w-100" color="primary">
              <input type="tel" matInput formControlName="phone" id="phone" (input)="onPhoneInput($event)"/>
              <mat-error *ngIf="userDetailForm.controls['phone'].hasError('invalidPhone')">
                {{"personal_details.phone_validator" | translate}}
              </mat-error>
            </mat-form-field>
          </div>
        <div class="col-sm-6" *ngIf="user?.roles">
            <mat-label class="f-s-14 f-w-600 m-b-8 d-block">{{ "personal_details.role" | translate }}</mat-label>
                <mat-form-field appearance="outline" class="w-100" color="primary">
                  <input matInput [value]="user?.roles?.name" [disabled]=true readonly id="role"/>
                </mat-form-field>
        </div>
        <div class="col-sm-6" *ngIf="user?.company">
            <mat-label class="f-s-14 f-w-600 m-b-8 d-block">{{ "personal_details.company" | translate }}</mat-label>
            <mat-form-field appearance="outline" class="w-100" color="primary">
                <input matInput [value]="user?.company?.name" [disabled]=true readonly id="company"/>
            </mat-form-field>
        </div>

        <div class="col-12 m-t-24">
          <button mat-flat-button color="primary" class="m-r-8" type="submit" [disabled]="!userDetailForm.valid">
            {{ "personal_details.save_changes" | translate }}
          </button>
          <button mat-stroked-button type="button" (click)="resetForm()">{{ "personal_details.reset" | translate }}
          </button>
        </div>

    </div>
    </form>

  </mat-card-content>
</mat-card>
